import { Box, Typography, useTheme, Avatar } from "@mui/material";

import Header from "components/Header";
import { Person2Outlined } from "@mui/icons-material";


const ProfessionalsPage = () => {
    const theme = useTheme();

    return (
        <Box m="1.5rem 2.5rem">
            <Header title="Book an Appointment" subtitle="" />
            <Box marginTop="10px" alignItems="left">
                <Box width="40%" display="flex" flexDirection="column" rowGap="15px" sx={{ borderRadius: '20px', padding: 1 }} >
                    <Box sx={{
                        border: `1px solid ${theme.palette.secondary[200]}`, borderRadius: '20px', padding: 1, transitionDelay: "0.3s", // smooth hover
                        "&:hover": {
                            bgcolor: `${theme.palette.secondary[300]}`,   // changes on hover

                        }
                    }} display="flex" flexDirection="row" alignItems="center">

                        <Avatar sx={{ bgcolor: "#665429", width: 75, height: 75 }}>

                        </Avatar>
                        <Typography marginLeft="10px">
                            <strong>Renuka Jiothiswaroopan
                            </strong><br />
                            Special Educator
                            <br />
                            rjiothi@gmail.com
                        </Typography>
                    </Box>
                    <Box sx={{
                        border: `1px solid ${theme.palette.secondary[200]}`, borderRadius: '20px', padding: 1,
                        transitionDelay: "0.3s", // smooth hover
                        "&:hover": {
                            bgcolor: `${theme.palette.secondary[300]}`,   // changes on hover

                        }
                    }} display="flex" flexDirection="row" alignItems="center">
                        <Avatar sx={{ bgcolor: "#665429", width: 75, height: 75 }}>

                        </Avatar>
                        <Typography marginLeft="10px">
                            <strong>Kavita Shah
                            </strong><br />
                            Special Educator
                            <br />
                            kavitashah.asha@gmail.com
                        </Typography>
                    </Box>

                </Box>
                <Box>
                </Box>
            </Box>
        </Box>
    );
};

export default ProfessionalsPage;
